module.exports = __webpack_public_path__ + "static/media/trafficlightgreen.0bccbda3.png";